<template>
  <HeaderBar />
  <NoticeToast :model="$store.state.toast" />
  <div class="outer-wrapper">
    <MenuBar :loggedIn="loggedIn" />
    <div class="main-wrapper">
      <div class="wrapper-header">
        <div class="wrapper-header-title-wrapper">
          <router-link v-if="this.breadCrumbs.length>0"
                       :to="this.breadCrumbs[this.breadCrumbs.length-1].link"
                       class="breadcrumb"
          >
            {{ this.breadCrumbs[this.breadCrumbs.length - 1].title }}
          </router-link>
          <div class="wrapper-header-title">
            <router-link v-if="this.breadCrumbs.length>0"
                         :to="this.breadCrumbs[this.breadCrumbs.length-1].link"
                         class="main-back"
                         v-html="getSVG('arrow_left')"
            />
            <h1>{{ pageTitle }}</h1>
          </div>
        </div>
      </div>
      <template v-if="loggedIn">
        <router-view name="tabBar" />
      </template>
      <div class="scroll-wrapper">
        <div class="scroll-wrapper-inner">
          <template v-if="loggedIn">
            <router-view />
          </template>
          <template v-else>
            <LoginPage />
            <div class="login-background"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <ConfirmationOverlay />
  <LibraryRightClickBox />
</template>

<script>
import HeaderBar from "@/components/static/HeaderBar.vue";
import NoticeToast from "@/components/elements/NoticeToast.vue";
import MenuBar from "@/components/static/MenuBar.vue";
import LoginPage from "@/components/views/login/login.vue";
import ConfirmationOverlay from "@/components/snippets/ConfirmationOverlay.vue";
import LibraryRightClickBox from "@/components/snippets/LibraryRightClickBox.vue";

export default {
  data() {
    return {};
  },
  components: {
    HeaderBar,
    MenuBar,
    NoticeToast,
    LoginPage,
    ConfirmationOverlay,
    LibraryRightClickBox,
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle
    },
    loggedIn() {
      return this.reloadUser();
    },
    breadCrumbs() {
      return this.$store.state.breadCrumbs;
    },
  },
  methods: {
    async loadTenantConfig() {
      const res = await this.apiRequest('GET', '/tenant', null, false);
      if(res && res.success) {
        this.$store.commit('setTenantConfig', res);
        if(res.primaryColor) {
          document.documentElement.style.setProperty('--son-dunkelgrau', res.primaryColor);
        }
        if(res.accentColor) {
          document.documentElement.style.setProperty('--son-gelb', res.accentColor);
        }
        if(res.backgroundColor) {
          document.documentElement.style.setProperty('--son-hellgrau', res.backgroundColor);
        }
        if(res.menuActiveColor) {
          document.documentElement.style.setProperty('--menu-active', res.menuActiveColor);
        }
        if(res.menuActiveIconColor) {
          document.documentElement.style.setProperty('--menu-active-icon', res.menuActiveIconColor);
        }
        if(res.toggleColor) {
          document.documentElement.style.setProperty('--toggle-active', res.toggleColor);
        }
        if(res.loginBackgroundUrl) {
          document.documentElement.style.setProperty('--login-bg-image', 'url(' + res.loginBackgroundUrl + ')');
        }
        // Custom Fonts laden
        if(res.font400 || res.font500 || res.font700) {
          let fontCSS = '';
          const weights = {'400': res.font400, '500': res.font500, '700': res.font700};
          for(const [weight, url] of Object.entries(weights)) {
            if(url) {
              fontCSS += `@font-face { font-family: 'Custom Font'; font-weight: ${weight}; font-style: normal; font-display: swap; src: url('${url}'); }\n`;
            }
          }
          if(fontCSS) {
            const style = document.createElement('style');
            style.textContent = fontCSS;
            document.head.appendChild(style);
            document.documentElement.style.setProperty('--font-family', "'Custom Font', sans-serif");
          }
        }
      }
    },
  },
  mounted() {
    document.addEventListener("contextmenu", this.openFileActionOverlay);
    this.loadTenantConfig();
  }
}
</script>
